export default "__VITE_ASSET__C$Zx3l2l__"